// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3Yldh","inputWrap":"CustomTip_inputWrap__TVumv"};